import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  overflow: hidden;
`;

const BgImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('/images/barn-fall.jpg');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;

  @media (max-width: 768px) {
    background-attachment: scroll;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.6);
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  max-width: 900px;
  margin: 0 auto;
  padding: 120px 40px;

  @media (max-width: 768px) {
    padding: 100px 20px;
  }
`;

const Label = styled.div`
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: var(--barn-red);
  margin-bottom: 20px;

  &::after {
    content: '';
    display: inline-block;
    width: 50px;
    height: 2px;
    background: var(--barn-red);
    margin-left: 12px;
    vertical-align: middle;
  }
`;

const Title = styled.h2`
  font-size: clamp(2.5rem, 6vw, 4rem);
  color: var(--earth);
  margin-bottom: 40px;
`;

const StoryCard = styled.div`
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 45px;
  margin-bottom: 30px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.08);
  border: 1px solid rgba(139, 35, 35, 0.08);

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

const CardTitle = styled.h3`
  font-size: 1.5rem;
  color: var(--earth);
  margin-bottom: 18px;
`;

const StoryText = styled.p`
  font-size: 1.1rem;
  color: var(--earth-light);
  line-height: 1.9;

  &:not(:last-child) {
    margin-bottom: 18px;
  }
`;

const Highlight = styled.span`
  color: var(--barn-red);
  font-weight: 700;
`;


export default function OurStory() {
  return (
    <Section id="our-story">
      <BgImage />
      <Overlay />

      <Content>
        <Label>Our Story</Label>
        <Title>Our Story</Title>

        <StoryCard>
          <CardTitle>How It All Began</CardTitle>
          <StoryText>
            We started <Highlight>Red Barn Gardens in 2012</Highlight> after we
            purchased our first greenhouse. We started out small but now have
            3 greenhouses to provide you with the best quality plants, best
            variety, and finest selection around.
          </StoryText>
        </StoryCard>

        <StoryCard>
          <CardTitle>The Event Venue</CardTitle>
          <StoryText>
            Our event venue came about when a friend asked to have his daughter's
            birthday party in our greenhouse. We set up tables and chairs, used
            our hanging baskets for decorating. The kids and parents both loved it!
          </StoryText>
          <StoryText>
            From that one birthday party, we've grown into a unique event space
            that hosts weddings, showers, celebrations, and gatherings of all kinds
            for 20 to 100 people.
          </StoryText>
        </StoryCard>
      </Content>
    </Section>
  );
}
